<mip-users-list
  class="__list"
  [usersList]="profiles"
  [isLoading]="loading"
  [disableListLimit]="isAuthenticated"
  [showFollowBottom]="true"
  (onReachingBottom)="_onReachingBottom()"
></mip-users-list>
